import { render, staticRenderFns } from "./waterSamplesTable.vue?vue&type=template&id=ec842534"
import script from "./waterSamplesTable.vue?vue&type=script&lang=js"
export * from "./waterSamplesTable.vue?vue&type=script&lang=js"
import style0 from "./waterSamplesTable.vue?vue&type=style&index=0&id=ec842534&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports